import { defineMessages } from 'react-intl';

export const totalPointsEarnedMessages = defineMessages({
  'total-points-earned:subtitle': {
    id: 'total-points-earned:subtitle',
    defaultMessage: 'Lifetime Points Earned',
    description: 'Subtitle under the total lifetime points hero on the Receipts page',
  },
});
